module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    class: {
      'long-insult': _vm.isLongInsult
    }
  }, [_vm._v(_vm._s(_vm.insult))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.answerCount) + " / " + _vm._s(_vm.amount))]), _vm._v(" "), _c('button', {
    staticClass: "ripple-button button",
    on: {
      "click": _vm.restartGame
    }
  }, [_vm._v("\n    Restart\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "custom-tweet-button"
  }, [_c('a', {
    attrs: {
      "href": ("https://twitter.com/intent/tweet?text=" + ((_vm.twitterText))),
      "target": "_blank",
      "alt": "Tweet your score"
    }
  }, [_c('i', {
    staticClass: "btn-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "btn-text"
  }, [_vm._v("Tweet your score")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "ranking-link",
    attrs: {
      "to": "ranking"
    }
  }, [_c('h3', [_c('svg', {
    attrs: {
      "fill": "#66BB6A",
      "height": "24",
      "viewBox": "0 0 24 12",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z"
    }
  })]), _vm._v("\n      See High Scores\n    ")])]), _vm._v(" "), (_vm.answerCount !== _vm.amount) ? _c('div', {
    staticClass: "learning-suggestion"
  }, [_c('a', {
    attrs: {
      "href": _vm.currentLogo.url,
      "target": "_blank"
    }
  }, [_c('js-logo', {
    attrs: {
      "size": 55
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("\n      I am \n      "), _c('a', {
    attrs: {
      "href": _vm.currentLogo.url,
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.currentLogo.name) + "!")])]), _vm._v(" \n      Click me to learn more.\n    ")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-github-button"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/samiheikki/javascript-guessing-game",
      "target": "_blank",
      "alt": "Star samiheikki/javascript-guessing-game on GitHub"
    }
  }, [_c('i', {
    staticClass: "btn-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "btn-text"
  }, [_vm._v("Star on GitHub")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-088b1666"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResultPage.vue
// module id = 140
// module chunks = 1